<script lang="ts" setup>
  import { buttonVariants } from '@/components/ui/button'
  import { cn } from '@/lib/utils'
  import {
    RangeCalendarCellTrigger,
    type RangeCalendarCellTriggerProps,
    useForwardProps
  } from 'radix-vue'
  import { computed, type HTMLAttributes } from 'vue'

  const props = defineProps<RangeCalendarCellTriggerProps & { class?: HTMLAttributes['class'] }>()

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
  })

  const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <RangeCalendarCellTrigger
    :class="
      cn(
        buttonVariants({ variant: 'ghost' }),
        'h-9 w-9 p-0 font-normal data-[selected]:opacity-100',
        `[&[data-today]:not([data-selected])]:bg-purple-100
        [&[data-today]:not([data-selected])]:text-purple-700`,
        // Selection Start
        `data-[selection-start]:bg-purple-600 data-[selection-start]:text-white
        data-[selection-start]:hover:bg-purple-700 data-[selection-start]:hover:text-white
        data-[selection-start]:focus:bg-purple-600 data-[selection-start]:focus:text-white`,
        // Selection End
        `data-[selection-end]:bg-purple-600 data-[selection-end]:text-white
        data-[selection-end]:hover:bg-purple-700 data-[selection-end]:hover:text-white
        data-[selection-end]:focus:bg-purple-600 data-[selection-end]:focus:text-white`,
        // In Range
        'data-[in-range]:bg-purple-100 data-[in-range]:text-purple-900',
        // Outside months
        `data-[outside-view]:text-muted-foreground data-[outside-view]:opacity-50
        [&[data-outside-view][data-selected]]:bg-accent/50
        [&[data-outside-view][data-selected]]:text-muted-foreground
        [&[data-outside-view][data-selected]]:opacity-30`,
        // Disabled
        'data-[disabled]:text-muted-foreground data-[disabled]:opacity-50',
        // Unavailable
        'data-[unavailable]:text-destructive-foreground data-[unavailable]:line-through',
        props.class
      )
    "
    v-bind="forwardedProps"
  >
    <slot />
  </RangeCalendarCellTrigger>
</template>
